<template>
	<div class="container">
		<div class="card mb_0">
			<h3 class="title">{{ $t('merchant.transaction.text1') }}</h3>
			<div v-if="isShowList">
				<div class="d_flex align_items_end mt_20 merchant_list">
					<div class="info mr_10">
						<p class="mb_10">{{ $t('rtr_activity.start') }}</p>
						<date-picker
							is-required
							v-model="startDate"
							:model-config="{ type: 'string' }"
							:locale="$store.state.common.locale"
							mode="dateTime"
							is24hr
						>
							<template v-slot="{ inputValue, inputEvents }">
								<label class="calendar_area">
									<input
										class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
										:value="inputValue"
										v-on="inputEvents"
									/>
								</label>
							</template>
						</date-picker>
					</div>
					<div class="info mr_10">
						<p class="mb_10">{{ $t('rtr_activity.end') }}</p>
						<date-picker
							is-required
							v-model="endDate"
							:model-config="{ type: 'string' }"
							:locale="$store.state.common.locale"
							mode="dateTime"
							is24hr
						>
							<template v-slot="{ inputValue, inputEvents }">
								<label class="calendar_area">
									<input
										class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
										:value="inputValue"
										v-on="inputEvents"
									/>
								</label>
							</template>
						</date-picker>
					</div>
					<div class="info search mr_10">
						<input
							type="text"
							:placeholder="$t('input.placeholder.search_activity')"
						/>
					</div>
					<button class="mr_10" @click="loadTransactionList">
						{{ $t('button.search') }}
					</button>
					<button type="button" class="statement_button" @click="excelDownload">
						<span></span>
						<span>{{ $t('rtr_activity.button1') }}</span>
					</button>
				</div>

				<div class="transaction_history mt_20">
					<div v-if="transactionList.length === 0" class="list_none">
						<span class="ERRORGRAY"></span>
						<p>{{ $t('merchant.transaction.empty') }}</p>
					</div>
					<div v-else>
						<table class="table_type mb_40">
							<colgroup>
								<col style="width: 50px" />
								<col style="width: 50px" />
								<col style="width: 170px" />
								<col style="width: 170px" />
								<col style="width: 140px" />
								<col style="width: 140px" />
								<col style="width: 100px" />
								<col style="width: 120px" />
								<col style="width: 180px" />
							</colgroup>
							<thead>
								<tr>
									<th @click="checkboxHandler">
										<input
											class="ml_10 mr_10 checkbox"
											type="checkbox"
											v-model="isAllChecked"
										/>
									</th>
									<th>No</th>
									<!--									<th>결제시간</th>-->
									<!--									<th>거래명</th>-->
									<!--									<th>거래 ID</th>-->
									<!--									<th>결제자명</th>-->
									<!--									<th>거래유형</th>-->
									<!--									<th>상태</th>-->
									<!--									<th>결제금액</th>-->

									<th>{{ $t('merchant.transaction.table.time') }}</th>
									<th>{{ $t('merchant.transaction.table.name') }}</th>
									<th>{{ $t('merchant.transaction.table.id') }}</th>
									<th>{{ $t('merchant.transaction.table.payer') }}</th>
									<th>{{ $t('merchant.transaction.table.type') }}</th>
									<th>{{ $t('merchant.transaction.table.status') }}</th>
									<th>{{ $t('merchant.transaction.table.amount') }}</th>
								</tr>
							</thead>
							<tbody>
								<!--							<tr>-->
								<tr
									v-for="item in transactionList"
									:key="item.seq"
									@click="showDetail(item)"
								>
									<td @click.stop="">
										<input
											type="checkbox"
											class="checkbox ml_10 mr_10"
											v-model="item.checked"
										/>
									</td>
									<td>{{ item._no }}</td>
									<td>
										{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
									</td>
									<td>{{ item.title }}</td>
									<td>{{ item.transaction_id }}</td>
									<td>{{ item.payer_name }}</td>
									<td>{{ item.transaction_type }}</td>
									<td>{{ item.status }}</td>
									<td>{{ item.amount + ' ' + item.asset_code }}</td>
								</tr>
							</tbody>
						</table>
						<table>
							<tbody>
								<tr class="table02_tr">
									<td>{{ $t('merchant.transaction.total_count') }}</td>
									<td>
										{{ summary.count }}{{ $t('merchant.transaction.count') }}
									</td>
									<td>{{ $t('merchant.transaction.total_amount') }}</td>
									<td>{{ summary.sum }} JPYS</td>
								</tr>
							</tbody>
						</table>
						<pagination
							v-if="transactionList.length !== 0"
							:totalCount="pageNavigation.total_count"
							:totalPage="pageNavigation.total_page"
							:curPage="pageNavigation.cur_page"
							:point="pageNavigation.point"
							:firstPage="pageNavigation.first_page"
							:lastPage="pageNavigation.last_page"
							@change="pageChangeHandler"
						></pagination>
					</div>
				</div>
			</div>

			<div v-if="!isShowList" class="mt_20 transaction_detail">
				<table class="table_type_a">
					<colgroup>
						<col style="width: 180px" />
					</colgroup>
					<tbody>
						<tr>
							<th>{{ $t('merchant.transaction.table.order_no') }}</th>
							<td>{{ transactionInfo.order_id }}</td>
						</tr>
						<tr>
							<th>{{ $t('merchant.transaction.table.name') }}</th>
							<td>{{ transactionInfo.title }}</td>
						</tr>
						<tr>
							<th>{{ $t('merchant.transaction.table.id') }}</th>
							<td>{{ transactionInfo.transaction_id }}</td>
						</tr>
						<tr>
							<th>{{ $t('merchant.transaction.table.payer') }}</th>
							<td>{{ transactionInfo.payer_name }}</td>
						</tr>
						<tr>
							<th>{{ $t('merchant.transaction.table.amount') }}</th>
							<td>
								{{ transactionInfo.amount + ' ' + transactionInfo.asset_code }}
							</td>
						</tr>
						<tr>
							<th>{{ $t('merchant.transaction.table.type') }}</th>
							<td>{{ transactionInfo.transaction_type }}</td>
						</tr>
						<tr>
							<th>{{ $t('merchant.transaction.table.status') }}</th>
							<td>{{ transactionInfo.status }}</td>
						</tr>
						<tr>
							<th>{{ $t('merchant.transaction.table.time') }}</th>
							<td>
								{{
									$dayjs(transactionInfo.regdate).format('YYYY.MM.DD HH:mm:ss')
								}}
							</td>
						</tr>
					</tbody>
				</table>
				<div class="button_area">
					<button @click="back">{{ $t('button.back') }}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import pagination from '@/components/Pagination';
import { commonError } from '@/common/dialog';
import { fetchMerchantTransactionList } from '@/api/merchant';
import { mapGetters } from 'vuex';
import { utils, writeFile } from 'xlsx';
export default {
	name: 'TransactionList',
	components: {
		pagination,
	},
	data() {
		return {
			isAllChecked: false,
			excelHeaders: {
				no: 'No',
				regdate: this.$t('merchant.transaction.table.time'),
				title: this.$t('merchant.transaction.table.name'),
				transactionId: this.$t('merchant.transaction.table.id'),
				payerName: this.$t('merchant.transaction.table.payer'),
				transactionType: this.$t('merchant.transaction.table.type'),
				status: this.$t('merchant.transaction.table.status'),
				amount: this.$t('merchant.transaction.table.amount'),
			},
			transactionList: [],
			isShowList: true,
			startDate: this.$dayjs(new Date())
				.add(-6, 'month')
				.startOf('day')
				.toDate(),
			endDate: this.$dayjs(new Date()).endOf('day').toDate(),
			transactionInfo: {},
			pageNavigation: {},
			curPage: 1,
			listCount: 30,
			summary: {
				count: 0,
				sum: 0,
			},
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		isListAllCheck() {
			let check = this.transactionList.length > 0;
			this.transactionList.forEach(item => {
				if (!item.checked) {
					check = false;
					return false;
				}
			});
			return check;
		},
	},
	watch: {
		isListAllCheck() {
			this.isAllChecked = this.isListAllCheck;
		},
	},
	created() {
		this.init();
	},
	methods: {
		back() {
			this.isShowList = true;
		},
		init() {
			Promise.all([this.loadTransactionList()]);
		},
		async loadTransactionList() {
			let regdate_start = '',
				regdate_end = '';
			if (this.startDate) {
				regdate_start = new Date(this.startDate).getTime();
			}
			if (this.endDate) {
				regdate_end = new Date(this.endDate).getTime();
			}

			const { data, page_navigation } = await fetchMerchantTransactionList({
				...this.$route.query,
				...this.$route.params,
				regdate_start: regdate_start,
				regdate_end: regdate_end,
				page: this.curPage,
				list_count: this.listCount,
			}).catch(commonError);

			this.transactionList = data;
			this.pageNavigation = page_navigation;
			this.getSummary();
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadTransactionList();
		},
		getSummary() {
			let sum = 0;
			this.transactionList.forEach(item => {
				sum += item.amount * 1;
			});
			this.summary.count = this.transactionList.length;
			this.summary.sum = sum;
		},
		checkboxHandler() {
			this.transactionList.forEach(item => {
				item.checked = !this.isAllChecked;
			});
		},
		excelDownload() {
			const excelData = this.makeExcelData();
			if (!excelData) return;
			const dataWS = utils.json_to_sheet(excelData, {
				skipHeader: true,
			});
			const wb = utils.book_new();
			utils.book_append_sheet(wb, dataWS, 'transactionList');
			writeFile(wb, 'transactionList.xlsx');
		},
		makeExcelData() {
			const excelData = [];
			const checkedList = this.transactionList.filter(item => {
				return item.checked === true;
			});

			if (checkedList.length === 0) {
				alert(this.$t('alert.transaction_check'));
				return false;
			}
			excelData.push(this.excelHeaders);
			checkedList.forEach(item => {
				const obj = {
					no: item._no,
					regdate: this.$dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss'),
					title: item.title,
					transactionId: item.transaction_id,
					payerName: item.payer_name,
					transactionType: item.transaction_type,
					status: item.status,
					amount: `${item.amount} ${item.asset_code}`,
				};
				excelData.push(obj);
			});

			return excelData;
		},
		showDetail(transactionInfo) {
			this.transactionInfo = transactionInfo;
			this.isShowList = false;
		},
	},
};
</script>
